import { useQuery } from 'react-query';

// Services.
import { getCertMasterPlatformHighestRole } from 'services';
import { useProfile } from './useProfile';

import {
  CertMasterPlatformRole,
  CertMasterPlatformRoleResponse,
} from '@comptia-sso/core';

type UseCertMasterPlatformHighestRole = [CertMasterPlatformRoleResponse];

export const useCertMasterPlatformHighestRole = (
  profileId?: string,
): UseCertMasterPlatformHighestRole => {
  const profile = useProfile();

  const pidToUse = profileId ?? profile[0]?.id;
  const { data } = useQuery<CertMasterPlatformRoleResponse>(
    `certmasterplatformhighestrole-${pidToUse}`,
    () => {
      if (!pidToUse)
        return Promise.resolve({
          role: CertMasterPlatformRole.None,
        });
      return getCertMasterPlatformHighestRole(pidToUse);
    },
  );

  return [data ?? { role: CertMasterPlatformRole.None }];
};
